
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.324 8.148v11.798a2.892 2.892 0 01-2.878 2.878H4.054a2.892 2.892 0 01-2.878-2.878V5.554a2.892 2.892 0 012.878-2.878h13.322","fill":"#fefac0","fill-rule":"nonzero","stroke":"#f9e804","stroke-width":"1.92"}}),_c('path',{attrs:{"d":"M6.75 9l3.294 4.611a1.526 1.526 0 002.414.09l9.324-11.19","fill":"none","stroke":"#000","stroke-width":"4"}})])
          )
        }
      }
    